import { UserTitle } from 'types/GlobalInternalAccount'

export const translateTitle: Record<UserTitle, string> = {
  [UserTitle.CEO]: 'VD',
  [UserTitle.CFO]: 'Ekonomichef',
  [UserTitle.IT]: 'IT',
  [UserTitle.LESSOR]: 'Uthyrare',
  [UserTitle.TECHINCAL_MANAGER]: 'Chef inom teknisk förvaltning',
  [UserTitle.REGION_MANAGER]: 'Regions, distrikts- eller områdeschef',
  [UserTitle.FINANCE_CONTROLLER]: 'Ekonomicontroller',
  [UserTitle.CO_WORKER_TECHINCAL_MANAGEMENT]:
    'Medarbetare inom teknisk förvaltning',
  [UserTitle.MANAGEMENT_MANAGER]: 'Chef inom förvaltning',
  [UserTitle.CEO_ASSISTANT]: 'VD-assistent',
  [UserTitle.LESSOR_MANAGER]: 'Uthyrningschef'
}
